export default __webpack_public_path__ + "static/media/Accreditation-7.8229f380.png";